/* eslint-disable quotes */
import { HOSTNAME } from '@/utils'
import type { TypeLang, TypeJsonLdBrandsData } from '@/schema'
import { buildUrl, buildBreadcrumb, getIetfLang, BREADCRUMB_HOME } from './_url'
import { buildOrganization } from './_organization'

export function jsonLdBrands(data: TypeJsonLdBrandsData, locale: TypeLang) {
  const url = buildUrl(locale, '/brands')

  const brandItems = data.brands.map(brand => ({
    "@type": "Brand",
    "name": brand.name,
    "description": brand.description,
    "url": buildUrl(locale, `/brands/${brand.slug}`),
    "logo": `https://${HOSTNAME}/images/svg/logo--${brand.slug}.svg`
  }))

  const schema = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebPage",
        "@id": `${url}/#webpage`,
        "url": url,
        "name": data.name,
        "description": data.description,
        "inLanguage": getIetfLang(locale),
        "isPartOf": {
          "@id": `${buildUrl(locale)}/#website`
        },
        "breadcrumb": {
          "@id": `${url}/#breadcrumb`
        }
      },
      {
        ...buildBreadcrumb(locale, [
          { name: BREADCRUMB_HOME[locale], path: '' },
          { name: data.name, path: '/brands' }
        ]),
        "@id": `${url}/#breadcrumb`
      },
      {
        ...buildOrganization(locale, 'brief'),
        "@id": `${buildUrl(locale)}/#organization`,
        ...(brandItems.length > 0 && { "brand": brandItems })
      }
    ]
  }

  return JSON.stringify(schema)
}
